import content from 'constants/content';
import nonReturnableList, { returnableKeys } from 'constants/non-returnable';
import { NonReturnable } from '../../types/NonReturnable';

const combinedContent = {
  ...content,
  ...nonReturnableList,
};

export const renderContent = (id: string) => {
  const contentValue = combinedContent[`${id}`];

  if (contentValue === undefined) return '';

  return contentValue;
};

export const renderContentWithParams = ({ id, params }: { id: string; params: string[] }) => {
  let contentValue = content[`${id}`];

  if (contentValue === undefined) return '';

  if (params) {
    params.forEach((param, index) => {
      contentValue = contentValue.replace(`{${index}}`, param);
    });
  }

  return contentValue;
};

export const getReturnable = (returnableKey: string): NonReturnable | undefined => {
  if (!returnableKeys.includes(returnableKey)) return undefined;
  return {
    beforeLink: renderContent(`nonReturnable.${returnableKey}.beforeLink`),
    afterLink: renderContent(`nonReturnable.${returnableKey}.afterLink`),
    link: {
      text: renderContent(`nonReturnable.${returnableKey}.link.text`),
      href: renderContent(`nonReturnable.${returnableKey}.link.href`),
    },
  };
};
